<template>
  <div id="mainDiv" v-if="viewFlag">
    <el-form
      :model="queryForm"
      label-position="right"
      ref="queryForm"
      label-width="130px"
      class="systemFont1"
    >
      <el-row>
        <el-col :span="24">
          <!-- 个人用户检索入力框 -->
          <el-col :span="10" :offset="6">
            <el-form-item :label="$t('p0202.companyOrganizationName')">
              <el-input
                name="queryCriteria"
                type="text"
                v-model="queryForm.queryCriteria"
                clearable
                :placeholder="$t('p0202.companyOrganizationName')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <img
              src="../../assets/query2.svg"
              width="36px"
              height="36px"
              style="cursor: pointer"
              @click="getCompanyDetail(true)"
            />
          </el-col>
        </el-col>
      </el-row>
      <el-row><br /></el-row>
      <el-row>
        <el-col>
          <el-table
            ref="userDetailTable"
            :data="companyDetails"
            v-loading="pageLoading"
            tooltip-effect="dark"
          >
            <template slot="empty">
              <p>{{dataText}}</p>
            </template>
            <!-- 注册名称-->
            <el-table-column
              prop="companyName"
              :label="$t('p0202.companyRegisteredName')"
              align="left"
              min-width="160"
            ></el-table-column>
            <!-- 简称 -->
            <el-table-column
              prop="companyAbbrName"
              :label="$t('p0202.companyShortName')"
              align="left"
              min-width="90"
            ></el-table-column>
            <!-- 英文名称 -->
            <el-table-column
              prop="enName"
              :label="$t('p0202.englishName')"
              align="left"
              min-width="95"
            ></el-table-column>
            <!-- TQS注册日期 -->
            <el-table-column
              :formatter="registerDateFormat"
              prop="registerDate"
              :label="$t('p0212.registerDate')"
              align="center"
              width="124"
            ></el-table-column>
            <!-- 管理者 -->
            <el-table-column
              prop="managers"
              :label="$t('p0202.managers')"
              align="center"
              width="100"
            ></el-table-column>
            <!-- 人员数量 -->
            <el-table-column
              prop="numberOfPeople"
              :label="$t('p0202.numberOfPeople')"
              align="center"
              width="84"
            ></el-table-column>
            <!-- 上次更新 -->
            <el-table-column
              :formatter="lastUpdateDateFormat"
              prop="lastUpdateDate"
              :label="$t('p0212.lastUpdateDate')"
              align="center"
              width="98"
            ></el-table-column>
            <!-- 操作 -->
            <el-table-column :label="$t('p0212.operate')" align="center" width="98">
              <template slot-scope="scope">
                <!-- 详细 -->
                <el-button
                  size="mini"
                  type="text"
                  @click="detail(scope.row)"
                  >&nbsp;{{ $t("p0212.details") }}</el-button
                >
                <!-- 删除 -->
                <el-button
                  size="mini"
                  type="text"
                  @click="deleteRow(scope.row)"
                  >&nbsp;{{ $t("common.delete") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-row style="text-align: right; margin: 20px">
        <el-col :span="24">
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPageCo"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSizeCo"
              layout="total, sizes, prev, pager, next"
              :total="totalCo"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
      <el-row><br /><br /></el-row>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  data() {
    return {
      // 查询条件
      queryForm: {
        queryCriteria: "",
      },
      // 公司/机构名称一览
      companyDetails: [{
        companyName:"",
        companyAbbrName:"",
        enName:"",
        registerDate:"",
        managers:"",
        numberOfPeople:"",
        mCompanyId:"",
        userId:"",
      }],
      dataText: "",
      // 页面载入状态
      pageLoading: false,
      viewFlag: true,
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 20,
      totalCo: 0,
      viewFlag: true,
      tmpQueryStrCo: "",
    };
  },
  mounted() {
    if(sessionStorage.getItem('detailCo')){
      this.getCompanyMessageListFunc()
    }else{
      this.getCompanyDetail(true);
    }
  },
  methods: {
    // 个人用户一览检索
    getCompanyDetail(val) {
      if (val) {
        this.currentPageCo = 1;
        this.totalCo =0;
        // this.tmpQueryStrCo = this.queryForm.queryCriteria;
      }
      // this.queryForm.queryCriteria = this.tmpQueryStr;
      this.pageLoading = true;
      let url = "/api/companyOrganizationCustomers/selectCompanyList";
      this.$http
        .post(
          url,
          qs.stringify({
            queryCriteria: this.queryForm.queryCriteria,
            currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
            pageSizeCo: this.pageSizeCo,
            totalCo: this.totalCo,
          })
        )
        .then((response) => {
          this.pageLoading = false;
          // this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            if (response.data.data==null) {
              this.companyDetails=[]
                //为空时，结合国际化进行赋值
                if (localStorage.locale === "en") {
                  this.dataText = "No data";
                } else {
                  this.dataText = "暂无数据";
                }
                // this.$message.error(this.$t("p0212.noFindCompanyInfo"));
              }else{
                this.companyDetails = response.data.data;
                //判断是否初始化
                if (this.currentPageCo == 1) {
                  this.companyDetails = response.data.data;
                  this.totalCo =  this.companyDetails[0].totalCo;
                } else {
                  this.individualUserDetails = response.data.data;
                }
              }
            // console.log("this.companyDetails",this.companyDetails)
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    //TQS注册日期格式化时间
    registerDateFormat(row) {
      if(row.registerDate!=null&&row.registerDate!=""){
        return moment(row.registerDate).format("YYYY-MM-DD");
      }
    },
    //上次日期格式化时间
    lastUpdateDateFormat(row) {
      if(row.lastUpdateDate!=null&&row.lastUpdateDate!=""){
        return moment(row.lastUpdateDate).format("YYYY-MM-DD");
      }
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;

      //判断更改页码是否需要查询
      if (
        this.individualUserDetails == undefined ||
        this.individualUserDetails.length <= 0
      ) {
        return;
      }
      this.getCompanyDetail(false);
      console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.getCompanyDetail(false);
      console.log(`当前页: ${val}`);    
    },
    // 详细信息取得
    detail(row) {
      // alert("功能开发中，请耐心等待！");
      let p0202 =JSON.stringify({
        mCompanyId: row.mcompanyId,
      });
      sessionStorage.p0202 = p0202
      sessionStorage.p0203First="first"
      sessionStorage.setItem("totalCo",this.totalCo)
      sessionStorage.setItem("pageSizeCo",this.pageSizeCo)
      sessionStorage.setItem("currentPageCo",this.currentPageCo)
      sessionStorage.setItem("queryCriteriaCo", this.queryForm.queryCriteria)
      this.$router.push('/views/CustomerInfoBase/P0203')
    },
    deleteRow(row){
      // 是否删除该公司？
      this.$confirm(this.$t("p0205.deleteThisCompany"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: this.$t('common.loading'),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container"),
          });
          let url = "/api/companyOrganizationCustomers/deleteCompany";
          row.userId = localStorage.getItem("userId")
          this.$http
            .post(
              url,
              qs.stringify({
                userId: row.userId,
                mCompanyId: row.mcompanyId
              })
            )
            .then((response) => {
              this.pageLoading = false;
              this.response = JSON.stringify(response.data);
              if (response.data.code === 200) {
                this.$message({
                  message: this.$t("common.deletedSuccessfully"),
                  type: "success",
                });
                this.getCompanyDetail(true);
              } else {
                this.getCompanyDetail(true);
                this.$message.error(response.data.message);
              }
              loading.close()
            })
            .catch((err) => {
              console.log(err);
              loading.close()
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        })
          .catch(() => {});
    },
    //返回跳转前的页面
    getCompanyMessageListFunc(){ //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if(sessionStorage.getItem('detailCo')){
        //如果有这个就读取缓存里面的数据
      this.currentPageCo=Number(sessionStorage.getItem("currentPageCo"));
      this.totalCo = Number(sessionStorage.getItem("totalCo"));
      this.pageSizeCo = Number(sessionStorage.getItem("pageSizeCo"));
      this.queryForm.queryCriteria = sessionStorage.getItem("queryCriteriaCo");
      this.getCompanyDetail(false);
      sessionStorage.removeItem("detailCo");
      }else{
        this.currentPage=1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPageCo");
        sessionStorage.removeItem("totalCo");
        sessionStorage.removeItem("pageSizeCo");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#mainDiv {
  width: 88%;
  padding-left: 6%;
  padding-top: 3%;
  // border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

>>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
>>>.el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170)
}
>>>.el-table thead{
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  color: #333333;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0202.vue